import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ToastService } from "@shared/service/toast.service";
import { MessageType } from "@schema/message";

@Component({
  selector: "app-toast-list",
  templateUrl: "./toast-list.component.html",
  styleUrls: ["./toast-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastListComponent implements OnInit {

  constructor(
    public toastService: ToastService
  ) { }

  ngOnInit(): void { }

  /**
   * Get the icon class name for the given toast type
   *
   * @param type The type of toast
   */
  public getToastIconClass(type: MessageType): string|void {
    switch (type) {
      case MessageType.SUCCESS:
        return "fa-check";
      case MessageType.INFO:
        return "fa-info-circle";
      case MessageType.WARNING:
        return "fa-exclamation-triangle";
      case MessageType.ERROR:
        return "fa-times";
    }
  }

}
